import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { loadUserMe } from '../../state/user/user.actions';
import { selectSalesUserFromUser, selectCurrentUserMeResponse } from '../../state/user/user.selector';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { UserMeResponse } from '../../services/UserService';

@Component({
  selector: 'app-employee',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule],
  templateUrl: './employee.component.html',
  styleUrl: './employee.component.css'
})
export class EmployeeComponent implements OnInit {
  salesUser$!: Observable<any>;
  
  constructor(private store: Store) { }
  
  ngOnInit(): void {
    this.store.dispatch(loadUserMe());
    this.salesUser$ = this.store.select(selectSalesUserFromUser);
  }
}
